module.exports = __webpack_public_path__ + "static/media/gcloud.a508dd90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gcloud.svg
// module id = 1313
// module chunks = 49